export const canRender = (collection, block) => {
    let left = true;
    let right = true;
    let top = true;
    let bottom = true;
    collection.items.forEach((element) => {
        if (element.xpos === block.xpos && element.ypos === block.ypos) {
            return;
        }
        if (element.xpos === block.xpos - 1 && element.ypos === block.ypos) {
            left = false;
        }
        if (element.xpos === block.xpos + 1 && element.ypos === block.ypos) {
            right = false;
        }
        if (element.ypos === block.ypos - 1 && element.xpos === block.xpos) {
            top = false;
        }
        if (element.ypos === block.ypos + 1 && element.xpos === block.xpos) {
            bottom = false;
        }
    });
    return { left, right, top, bottom };
};
const renderShapeBorder = (collection, block, color, width = 4) => {
    const { left, right, top, bottom } = canRender(collection, block);
    const res = `${left ? `border-left:solid ${color} ${width}px` : ''};
                 ${right ? `border-right:solid ${color} ${width}px` : ''};
                 ${top ? `border-top:solid ${color} ${width}px` : ''};
                 ${bottom ? `border-bottom:solid ${color} ${width}px` : ''}; `;
    return res;
};
export default renderShapeBorder;
